import {
  BenefitSplitLimits,
  ForemanPromocode,
  ForemanPromocodesList,
  ForemanPromocodesPagination,
  PromoPaginationParams,
} from '@my-account/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

const getForemanPromocodesState: MemoizedSelector<StateWithMyAccount, MyAccountState['foremanPromocodes']> =
  createSelector(getMyAccountState, (state: MyAccountState) => state.foremanPromocodes);

// Benefit split limits

export const getBenefitSplitLimitsState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<BenefitSplitLimits>
> = createSelector(getForemanPromocodesState, (state) => state.benefitSplitLimits);

export const getBenefitSplitLimitsValue: MemoizedSelector<StateWithMyAccount, BenefitSplitLimits> = createSelector(
  getBenefitSplitLimitsState,
  (state) => StateUtils.loaderValueSelector(state),
);

export const getBenefitSplitLimitsLoading: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getBenefitSplitLimitsState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getBenefitSplitLimitsSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getBenefitSplitLimitsState,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getBenefitSplitLimitsError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getBenefitSplitLimitsState,
  (state) => StateUtils.loaderErrorSelector(state),
);

// Generated promocode

export const getGeneratedPromocodeState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<ForemanPromocode>
> = createSelector(getForemanPromocodesState, (state) => state.generatedPromocode);

export const getGeneratedPromocodeValue: MemoizedSelector<StateWithMyAccount, ForemanPromocode> = createSelector(
  getGeneratedPromocodeState,
  (state) => StateUtils.loaderValueSelector(state),
);

export const getGeneratedPromocodeLoading: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getGeneratedPromocodeState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getGeneratedPromocodeSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getGeneratedPromocodeState,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getGeneratedPromocodeError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getGeneratedPromocodeState,
  (state) => StateUtils.loaderErrorSelector(state),
);

// Promocodes list

export const getForemanPromocodesListState: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.LoaderState<ForemanPromocodesList>
> = createSelector(getForemanPromocodesState, (state) => state.list);

export const getForemanPromocodesListValue: MemoizedSelector<StateWithMyAccount, ForemanPromocodesList> =
  createSelector(getForemanPromocodesListState, (state) => StateUtils.loaderValueSelector(state));

export const getForemanPromocodesListLoading: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getForemanPromocodesListState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getForemanPromocodesListSuccess: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getForemanPromocodesListState,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getForemanPromocodesListError: MemoizedSelector<StateWithMyAccount, boolean> = createSelector(
  getForemanPromocodesListState,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getForemanPromocodesItems: MemoizedSelector<StateWithMyAccount, ForemanPromocode[]> = createSelector(
  getForemanPromocodesListValue,
  (list) => list?.items,
);

export const getForemanPromocodesPagination: MemoizedSelector<
  StateWithMyAccount,
  ForemanPromocodesPagination | undefined
> = createSelector(getForemanPromocodesListValue, (list) =>
  list
    ? { startIndex: list.startIndex, totalItems: list.totalItems, currentItemCount: list.currentItemCount }
    : undefined,
);

export const getForemanPromocodesParams: MemoizedSelector<StateWithMyAccount, PromoPaginationParams | undefined> =
  createSelector(getForemanPromocodesListValue, (list) => list?.params);
